<template>
    <div id="user-feedback" class="container">
        <div class="row mt-2">
            <div v-if="singleEmployer" class="col-12">
                <div class="alert alert-warning">
                    If your issue is non-technical in nature please contact your <a href="#" @click="showContactUsModal">client relationship manager <i class='fa fa-phone' /></a>
                </div>
            </div>

            <div>
              <label class="container">
                Submit a suggestion or idea to your development team. This does not guarantee an action and this is not a replacement for Jira. For all important requests, including bugs, please file a Jira ticket.
              </label>

              <amf-textarea :columns="4" :show-label="false" v-model="comments" :rows="4"  :validator="$v.comments" />
            </div>

            <amf-checkbox :columns="1" :label="'Include a screenshot'" v-model="includeScreenshot" />
            <div class="col-6" v-if="includeScreenshot">
                <img width="150" :src="frame" />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["screenshot"],
    inject: ['closeModal'],
    data() {
        return {
            comments: null,
            includeScreenshot: true,
            frame: this.screenshot,
        }
    },
    computed: {
        ...amfx.map("route", "routePath:path"),
        ...amfx.map("session", "userId,singleEmployer"),
        title() {
            return "Suggestion Box";
        }
    },
    methods: {
        async save() {
            this.busy = true;
            let formData = new FormData();
            formData.append('comments', this.comments);
            formData.append('url', this.routePath);
            if(this.includeScreenshot) formData.append('screenshot', this.frame.split(';base64,')[1]);
            await romeApi.upload(`/feedback`, formData);
            this.busy = false;
        },
        async showContactUsModal() {
            if (this.closeModal) this.closeModal({contactUs: true});
        }
    },
    validations() {
        return {
            comments: v.build(v.required()),
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/user/UserFeedback.vue